<template>
  <Form
    ref="formValidate"
    :model="submitData"
    :rules="ruleValidate"
    :label-width="80"
    class="edit-win"
  >
    <div>新增</div>
    <FormItem label="名称" prop="type">
      <RadioGroup v-model="submitData.type" type="button">
        <Radio :label="0">目录</Radio>
        <Radio :label="1">菜单</Radio>
        <Radio :label="2">按钮</Radio>
      </RadioGroup>
    </FormItem>
    <FormItem label="名称" prop="name">
      <Input v-model="submitData.name" placeholder="请输入名称" style="width: 300px"/>
    </FormItem>
    <FormItem label="上级菜单" prop="parentName">
      <div @click="showtree">
        <Input
          v-model="submitData.parentName"
          placeholder="点击选择上级菜单"
          readonly
          style="width: 300px"
        />
      </div>
      <Tree v-if="show" :data="menudata" @on-select-change="treeselect"></Tree>
    </FormItem>

    <FormItem v-if="submitData.type==1" label="菜单URL" prop="url">
      <Input v-model="submitData.url" placeholder="菜单URL" style="width: 300px"/>
    </FormItem>
    <FormItem v-if="submitData.type!=0" label="授权标识" prop="perms">
      <Input
        v-model="submitData.perms"
        placeholder="多个用逗号分隔, 如: user:list,user:create"
        style="width: 300px"
      />
    </FormItem>
    <FormItem v-if="submitData.type!=2" label="排序号" prop="orderNum">
      <InputNumber v-model="submitData.orderNum"></InputNumber>
    </FormItem>
    <FormItem>
      <Button @click="submitInfo" type="primary">确定</Button>
      <Button style="margin-left: 8px" @click="back">返回</Button>
    </FormItem>
  </Form>
</template>

<script>
export default {
  data() {
    return {
      menudata: [],
      show: false,
      submitData: {
        id: '',
        type: 0,
        name: '',
        parentId: 0,
        url: '',
        perms: '',
        orderNum: 0,
        parentName: ''
      },
      ruleValidate: {
        name: [
          { required: true, message: '名称不能为空', trigger: 'blur' }
        ],
        parentName: [
          { required: true, message: '上级菜单不能为空', }
        ],
        url: [
          { required: true, message: 'url', trigger: 'blur' }
        ],
      }
    }
  },
  created() {

    if (this.$route.query.id == false) {
      this.getmenuList()
      this.submitData.id = 0
      this.submitData.type = 1
      this.submitData.parentId = 0
      this.submitData.parentName = ''
      this.submitData.url = ''
      this.submitData.perms = ''
      this.submitData.orderNum = 0
      this.submitData.name = ''
    } else {
      this.getmenuList()
      this.$axios.get('sys/menu/info/' + this.$route.query.id)
        .then(function (response) {
          if (response.data.success) {
            this.submitData = response.data.data

            this.submitData.id = this.$route.query.id

          } else {
            this.$Message.error(response.data.errMsg);
          }
        }.bind(this))
    }
  },
  mounted() {
    // this.getmenuList()
  },
  methods: {
    getmenuList() {
      this.$axios.get('/sys/menu/select')
        .then(function (response) {
          if (response.data.success) {

            let tempNode
            let all = []
            let linshi = []
            for (let i = 0; i < response.data.data.length; i++) {
              let element = response.data.data[i]
              if (element.menuId == 0) {
                //格式化tree所需数据
                tempNode = {
                  id: element.menuId,
                  title: element.name,
                  expand: true,
                  children: []
                }
                all.push(tempNode)
                break
              }
            }
            linshi = this.getChild(0, response.data.data, this.submitData.parentId)

            for (var i = 0; i < linshi.length; i++) {
              all[0].children.push(linshi[i])
            }

            this.menudata = all
          } else {
            this.$Message.error(response.data.errMsg);
          }
        }.bind(this))
    },
    getChild(id, data, selected) {
      let tempList = []
      let tempNode
      //循环格式化tree所需数据
      for (let i = 0; i < data.length; i++) {
        let element = data[i]
        if (element.parentId == id) {
          //格式化tree所需数据
          tempNode = {
            id: element.menuId,
            title: element.name,
            expand: true,
            children: this.getChild(element.menuId, data, selected)
          }
          tempList.push(tempNode)
        }
      }
      return tempList
    },
    showtree() {
      this.show = true
    },
    treeselect(data) {

      this.show = false
      if (data != '') {
        this.submitData.parentName = data[0].title
        this.submitData.parentId = data[0].id
      }

    },
    submitInfo() {

      if (this.submitData.parentId !== '' && this.submitData.name !== '') {
        if (this.submitData.type == 1) {
          if (this.submitData.url !== '') {
            this.submitAxios()
          }
        } else {
          this.submitAxios()
        }

      }

    },
    submitAxios() {
      var params = {
        'menuId': this.submitData.id,
        'type': this.submitData.type,
        'name': this.submitData.name,
        'parentId': this.submitData.parentId,
        'url': this.submitData.url,
        'perms': this.submitData.perms,
        'orderNum': this.submitData.orderNum,
      }
      if (this.submitData.id == 0) {
        this.$Loading.start()
        this.$axios.post('/sys/menu/save', params)
          .then(function (response) {
            if (response.data.success) {
              this.$Loading.finish()
              this.$router.go(-1)
            } else {
              this.$Message.error(response.data.errMsg)
              this.$Loading.error()
            }
          }.bind(this))
      } else {
        this.$Loading.start()
        this.$axios.post('/sys/menu/update', params)
          .then(function (response) {
            if (response.data.success) {
              this.$Loading.finish()
              this.$router.go(-1)
            } else {
              this.$Message.error(response.data.errMsg);
              this.$Loading.error()
            }
          }.bind(this))
      }
    },
    back() {
      this.$router.go(-1)
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/views/menu/edit.vue